/**
 *
 * 评价和咨询客服model
 */

/**
 * 应用：
 * 1.h5重连-评价弹窗
 * 2.pc重连-评价弹窗
 */
import service from "../app/customer/service";
import utils from "src/app/customer/utils";
import main from "../main";
export default {
  computed: {
    ...mapState({
      blackFlag: state => state.blackFlag,
      orderImgUrls: state => state.orderImgUrls,
      isload: state => state.isload,
      urlData: state => state.urlData,
      hideHeader: state => state.hideHeader
    })
  },

  methods: {
    ...mapActions({
      initChannel: "initChannel"
    }),
    handleEvaluate() {
      //满意度评价事件
      if (this.blackFlag != 0) {
        this.$message.error("您暂时不能发起评价");
        return false;
      }
      this.$store.commit("setState", {
        visibleEvaluate: true
      });
    },
    async handleConnect() {
      if (this.hideHeader === "true" || this.hideHeader === true) {
        // 初次进入 URL，定义在 index.html
        if (window.__initialUrl) {
          this.$store.commit("setState", { isload: true });
          window.location.href = window.__initialUrl;
        }
        // window.parent.postMessage({ refresh: true }, "*");
      } else {
        await utils.getDoMain();
        const { store } = main.getVueMachine();
        if (store.state.SysNotice) {
          store.commit("setState", { isload: false });
          return false;
        }
        localStorage.removeItem("count");
        this.$store.commit("setState", {
          isUploadImg: false,
          isload: true,
          serverAvatar: "",
          serverImage: ""
        });
        console.log(this.urlData.enterScene);
        if (this.urlData.enterScene == 5) {
          this.$store.commit("clearAllMessages");
          this.$store.dispatch("initChannel", {
            orderImgUrls: "",
            router: this.$router
          });
        } else {
          const { data: questionTypes } = await service.queryCusSkill();
          this.$store.commit("clearAllMessages"); //清空数据
          this.$store.commit("setState", {
            triggerId: 0,
            enterScene: 0,
            questionTypes,
            isload: false
          });
          this.$router.push("before-page");
        }
      }
    }
  }
};
